import styled from 'styled-components';

export const PaymentMethodContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 1rem 0;
  cursor: pointer;
  max-width: 350px;
`;

export const DefaultPaymentMethodSelector = styled.div`
  width: 2rem;
`;

export const AddPaymentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 1rem 0;
  cursor: pointer;
  max-width: 350px;
`;

export const PaymentIconContainer = styled.div`
  padding-left: 0.5rem;
  padding-right: 1.5rem;
  width: 50px;
`;

export const PaymentName = styled.div`
  padding-right: 3rem;
  min-width: 230px;
`;

export const PaymentSmallText = styled.span`
  font-size: 14px;
`;

export const PaymentLogo = styled.img`
  width: 2rem;
`;

export const PaymentLogoContainer = styled.div`
  width: 2rem;
`;

export const StripeIbanInputContainer = styled.div`
  .StripeElement {
    margin-top: 4px;
  }
`;
